module.exports = __webpack_public_path__ + "img/imgImgHome06.b01999f6.svg";